/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FuelUpBoardSpace } from './FuelUpBoardSpace';
import {
    FuelUpBoardSpaceFromJSON,
    FuelUpBoardSpaceFromJSONTyped,
    FuelUpBoardSpaceToJSON,
    FuelUpBoardSpaceToJSONTyped,
} from './FuelUpBoardSpace';
import type { RewardResponseObject } from './RewardResponseObject';
import {
    RewardResponseObjectFromJSON,
    RewardResponseObjectFromJSONTyped,
    RewardResponseObjectToJSON,
    RewardResponseObjectToJSONTyped,
} from './RewardResponseObject';

/**
 * 
 * @export
 * @interface FuelUpMoveResponseMoveResult
 */
export interface FuelUpMoveResponseMoveResult {
    /**
     * 
     * @type {number}
     * @memberof FuelUpMoveResponseMoveResult
     */
    spacesMoved?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelUpMoveResponseMoveResult
     */
    newPosition?: number;
    /**
     * 
     * @type {FuelUpBoardSpace}
     * @memberof FuelUpMoveResponseMoveResult
     */
    landedSpace?: FuelUpBoardSpace;
    /**
     * RewardConfig IDs available to claim from landed space
     * @type {Array<string>}
     * @memberof FuelUpMoveResponseMoveResult
     */
    pendingRewardConfigIds?: Array<string>;
    /**
     * Loop finish reward(s) granted automatically on loop completion
     * @type {Array<RewardResponseObject>}
     * @memberof FuelUpMoveResponseMoveResult
     */
    loopCompletionRewards?: Array<RewardResponseObject>;
    /**
     * 
     * @type {string}
     * @memberof FuelUpMoveResponseMoveResult
     */
    specialEvent?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FuelUpMoveResponseMoveResult
     */
    loopCompleted?: boolean;
}

/**
 * Check if a given object implements the FuelUpMoveResponseMoveResult interface.
 */
export function instanceOfFuelUpMoveResponseMoveResult(value: object): value is FuelUpMoveResponseMoveResult {
    return true;
}

export function FuelUpMoveResponseMoveResultFromJSON(json: any): FuelUpMoveResponseMoveResult {
    return FuelUpMoveResponseMoveResultFromJSONTyped(json, false);
}

export function FuelUpMoveResponseMoveResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelUpMoveResponseMoveResult {
    if (json == null) {
        return json;
    }
    return {
        
        'spacesMoved': json['spacesMoved'] == null ? undefined : json['spacesMoved'],
        'newPosition': json['newPosition'] == null ? undefined : json['newPosition'],
        'landedSpace': json['landedSpace'] == null ? undefined : FuelUpBoardSpaceFromJSON(json['landedSpace']),
        'pendingRewardConfigIds': json['pendingRewardConfigIds'] == null ? undefined : json['pendingRewardConfigIds'],
        'loopCompletionRewards': json['loopCompletionRewards'] == null ? undefined : ((json['loopCompletionRewards'] as Array<any>).map(RewardResponseObjectFromJSON)),
        'specialEvent': json['specialEvent'] == null ? undefined : json['specialEvent'],
        'loopCompleted': json['loopCompleted'] == null ? undefined : json['loopCompleted'],
    };
}

export function FuelUpMoveResponseMoveResultToJSON(json: any): FuelUpMoveResponseMoveResult {
    return FuelUpMoveResponseMoveResultToJSONTyped(json, false);
}

export function FuelUpMoveResponseMoveResultToJSONTyped(value?: FuelUpMoveResponseMoveResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'spacesMoved': value['spacesMoved'],
        'newPosition': value['newPosition'],
        'landedSpace': FuelUpBoardSpaceToJSON(value['landedSpace']),
        'pendingRewardConfigIds': value['pendingRewardConfigIds'],
        'loopCompletionRewards': value['loopCompletionRewards'] == null ? undefined : ((value['loopCompletionRewards'] as Array<any>).map(RewardResponseObjectToJSON)),
        'specialEvent': value['specialEvent'],
        'loopCompleted': value['loopCompleted'],
    };
}

